<template>
  <div
    v-loading.fullscreen.fixed="loading"
    class="m-bookingCode-warp"
  >
    <VPopup
      v-model="visible"
      type="popup-bottom"
      class="m-bookingCode-content"
      @close="close"
    >
      <div
        v-if="visible"
        class="m-bookingCode"
        :class="{
          'm-bookingCode--small': bettableBetSlip.length < 3
        }"
      >
        <div class="top">
          <div class="code">
            <div class="code-value tw-rounded-[20px]">
              {{ code }}
            </div>
            <img
              src="./images/icon-share.png"
              class="icon tw-w-[26px]"
              @click="shareBookingCode"
            >
          </div>

          <div
            v-if="showFollowedTimes"
            class="followed-times"
          >
            <span>Code Followed Times:</span>
            <span>{{ followedTimesFormat }}</span>
          </div>

          <div class="description">
            {{ description }}
          </div>
        </div>

        <div class="content">
          <div class="bet-warp">
            <BookingCodeItem
              v-for="(item, key) in bettableBetSlip"
              :key="key"
              :data="item"
            />
          </div>
          <div class="footer">
            <VButton
              :loading="buttonLoading"
              @click="handleClick"
            >
              Add to Betslip
            </VButton>
          </div>
        </div>
      </div>
    </VPopup>

    <Share
      v-model="shareVisible"
      class="m-bookingCode-share"
      :has-hide-amount-btn="false"
      :share-imgs="shareImgs"
      :share-url="shareUrl"
      channel-prefix="share_bookingCode"
      :copy-link-show="false"
      @close="onCloseShare"
    >
      <div
        v-if="shareVisible"
        slot="share-top"
        class="m-share-booking-code"
      >
        <span class="m-value">{{ code }}</span>
      </div>
    </Share>

    <ShareTicket
      ref="shareContainer"
      :show-footer-buttons="false"
      :is-show-ticket-subject="false"
      is-share
    >
      <div
        slot="after-header"
        class="share-booking-info"
      >
        <div class="top-detail">
          <div class="code-value">
            {{ code }}
          </div>

          <div class="followed-times">
            <span>Code Followed Times:</span>
            <span>{{ followedTimesFormat }}</span>
          </div>

          <div class="description">
            {{ description }}
          </div>
        </div>

        <div class="bet-warp">
          <BookingCodeItem
            v-for="(item, key) in bettableBetSlip"
            :key="key"
            :data="item"
            :is-share="true"
          />
        </div>
      </div>
    </ShareTicket>
  </div>
</template>

<script>
import { storeToRefs } from 'pinia'
import { useGlobalConfigStore } from '@ms/stores/globalConfig'
import axios from 'crypto-fetch/axios'
import VPopup from 'fe-vui/popup'
import VButton from 'fe-vui/button'
import toast from 'fe-vui/toast'
import { useWapBetslipStore } from 'wap/stores/betslip'
import { formatNumber } from '@ms/utils/format'
import modalHelper from '@ms/utils/scroll-fixed'
import { drawHtml } from '@ms/utils/draw.js'
import { DEFAULT_ERROR_TEXT } from '@ms/config/message'
import { getMultipleName, getBetCount, getTotalOddsRange, getMaxOddsForBets } from '@ms/components/betslip/calculate.js'
import { traceBookingCodeKol } from '@ms/components/betslip/useBookingCode.js'
import useAddToBetslip from './useAddToBetslip.js'
import { replaceState } from '@ms/utils/replaceState.js'
import parse from 'url-parse'
import { Share, ShareTicket } from 'wap/components/index.js'
import BookingCodeItem from './components/BookingCodeItem'
import { traceKol } from '@ms/utils/track.js'

export default {
  name: 'BookingCode',
  components: {
    VButton,
    VPopup,
    Share,
    ShareTicket,
    BookingCodeItem
  },
  props: {
    code: {
      type: String,
      default: ''
    },
    // 最长 selection 个数, 传0则不做超长提示
    maxSelection: {
      type: Number,
      default: 30
    }
  },
  setup() {
    const { maxLimitOdds } = storeToRefs(useGlobalConfigStore())
    const { addToBetslip, buttonLoading, fetchAddToBetslip } = useAddToBetslip()

    return {
      maxLimitOdds,
      addToBetslip,
      buttonLoading,
      fetchAddToBetslip
    }
  },
  data() {
    return {
      visible: false,
      loading: false,
      followedTimes: 0,
      showFollowedTimes: 0, // 1展示followedTimes
      bettableBetSlip: [],
      originalSelectionCount: 0,

      // share
      shareVisible: false,
      shareImgs: [],
      shareUrl: ''
    }
  },
  computed: {
    followedTimesFormat() {
      return this.followedTimes > 99999 ? '99,999+' : formatNumber(this.followedTimes) || 0
    },
    selectionList() {
      return this.bettableBetSlip.map((bet) => {
        const obj = { ...bet.event }
        obj.outcomeInfo = { ...bet.outcome }
        return obj
      })
    },
    multipleLength() {
      // 去重后event数量
      const arr = this.bettableBetSlip.map((bet) => {
        return bet.event.eventId
      })
      const _arr = Array.from(new Set(arr))
      return _arr.length
    },
    maxBetOdds() {
      return getMaxOddsForBets(this.selectionList, this.multipleLength)
    },
    // 为去重总odds
    initialTotalOdds() {
      return getTotalOddsRange(this.selectionList, this.multipleLength, this.maxLimitOdds)
    },
    totalOdds() {
      const min = Math.min(this.initialTotalOdds[0], this.maxLimitOdds)
      const max = Math.min(this.maxBetOdds, this.maxLimitOdds)
      return [min, max]
    },
    multipleName() {
      return getMultipleName(this.multipleLength)
    },
    betCount() {
      return getBetCount(this.selectionList, this.multipleLength)
    },
    showTotalOdds() {
      const arr = this.totalOdds.map((x) => {
        return x.toFixed(3).slice(0, -1)
      })
      return arr[0] === arr[1] ? formatNumber(arr[0]) : formatNumber(arr[0]) + '~' + formatNumber(arr[1])
    },
    description() {
      return `${this.multipleName} ${this.betCount}X ${this.showTotalOdds}`
    },
    isMatchDetail() {
      return this.$route ? this.$route.name === 'matchDetail' : false
    }
  },
  watch: {
    code(val) {
      if (val) {
        this.bettableBetSlip = []
        this.initFetch()
      }
    }
  },
  // created () {
  //   this.initFetch()
  //   modalHelper.afterOpen()
  // },
  beforeDestroy() {
    modalHelper.beforeClose()
    this.$emit('close')
  },
  methods: {
    async initFetch() {
      this.loading = true
      try {
        const { bizCode, data, message } = await axios.get(`/orders/real-sports/order/share/${this.code}`, { self: true })
        if (bizCode === 10000 && data) {
          this.loading = false
          this.followedTimes = data.followedTimes
          this.showFollowedTimes = data.showFollowedTimes
          this.bettableBetSlip = data.bettableBetSlip
          this.originalSelectionCount = data.originalSelectionCount
          this.$nextTick(this.open)
        } else {
          this.loading = false
          toast(message)
          this.close()
        }
      } catch (error) {
        this.loading = false
        console.error(error)
        toast(DEFAULT_ERROR_TEXT)
        this.close()
      }
    },
    async shareBookingCode() {
      // 分享弹窗
      this.loading = true
      try {
        if (!this.shareContainer) {
          this.shareContainer = this.$refs.shareContainer.$el
        }

        const shareUrl = `${location.origin}/${this.$region}?code=${this.code}`
        this.shareUrl = traceKol(shareUrl)

        // 等待绘图组件渲染完毕
        this.$nextTick(async () => {
          const { data } = await drawHtml(this.shareContainer)
          // 清除缓存的图片
          if (this.shareImgs.length > 0) {
            this.shareImgs.length = 0
          }
          this.shareImgs.push(data)
          this.loading = false
          this.shareVisible = true
        })
      } catch (error) {
        console.error(error)
        this.loading = false
        this.$dialog({
          message: error.message,
          showClose: false,
          confirmButtonText: 'OK',
          cancelButtonText: null
        }).catch(console.log)
      }

      if (this.isMatchDetail) {
        window.mstrace('MatchDetail_ShareBtn')
      } else {
        window.mstrace('codeTalk_code_codeDetail_ShareBtn')
      }
    },
    onCloseShare() {
      modalHelper.beforeClose()
      this.shareVisible = false
    },
    async handleClick() {
      const shareCode = this.code
      if (this.isMatchDetail) {
        this.addWithBetslip(shareCode)
        window.mstrace('MatchDetail_AddBtn')
      } else {
        const routeQuery = this.$route ? this.$route.query : parse(location.href, true).query
        if (!this.maxSelection) {
          // 无超长限制
          this.fetchAddToBetslip(shareCode, routeQuery.from)
          this.$emit('submit')
        } else {
          const { exceed, cancelled } = await useWapBetslipStore().addSelectionsFromShareCode(this.bettableBetSlip, shareCode)
          if (!exceed || !cancelled) {
            const channel = await traceBookingCodeKol(shareCode, routeQuery.from)
            // 添加渠道号
            if (channel) {
              const query = { ...routeQuery, from: channel }
              if (this.$router) {
                this.$router.replace({ query })
              } else {
                replaceState(query)
              }
            }
            this.fetchAddToBetslip(shareCode, channel)
            this.$emit('submit')
          }
        }
      }
    },
    async addWithBetslip(shareCode) {
      this.loading = true
      try {
        const { exceed, cancelled } = await useWapBetslipStore().getShareBetslips(shareCode)
        this.closeInnerLoading()
        if (!exceed && !cancelled) {
          this.addToBetslip(shareCode)
          useWapBetslipStore().subBetslip()
          toast('Successfully loaded')

          const channel = await traceBookingCodeKol(shareCode, this.$route.query.from)
          // 添加渠道号
          if (channel) {
            const query = { ...this.$route.query, from: channel }
            this.$router.replace({ query })
          }
          this.close()
        }
      } catch (err) {
        this.errText = err.message
        this.closeInnerLoading()
      }
    },
    closeInnerLoading() {
      modalHelper.beforeClose()
      this.loading = false
    },
    open() {
      // open detail
      this.visible = true
    },
    close() {
      modalHelper.beforeClose()
      this.visible = false
      this.$emit('close')
    }
  }
}
</script>

<style lang="less" scoped>
.m-bookingCode-warp {
  position: relative;
  z-index: 1100;

  .m-bookingCode-content .popup-wrap {
    left: 50%;
    max-width: 750px;
    margin: 0 auto;
    background: transparent;
    transform: translateX(-50%);
  }
}

.m-bookingCode {
  position: relative;
  height: 76vh;
  padding: 25px 2px 0;
  border-radius: 16px 16px 0 0;
  background: #f2f2f2;
  color: #333;
  text-align: left;

  &.m-bookingCode--small {
    height: auto;
    min-height: 55vh;
  }

  & .top {
    padding: 0 18px;
  }

  .code {
    position: absolute;
    top: 0;
    left: 50%;
    display: flex;
    height: 30px;
    align-items: center;
    padding: 0 6px 0 2px;
    border-radius: 18.55px;
    background-image: linear-gradient(134deg, #ffe74f 0%, #ffca27 40%);
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 40%);
    color: #ffe74f;
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 30px;
    transform: translate(-50%, -50%);

    .code-value {
      padding: 0 15px;
      margin-right: 4px;
      background-image: linear-gradient(231deg, #333 0%, #141414 100%);
      line-height: 24px;
    }
  }

  .followed-times {
    margin: 0 0 8px;
    color: #333;
    font-size: 12px;
    line-height: 16px;
  }

  & .row {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  & .description {
    color: #713802;
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 20px;
  }

  .content {
    position: absolute;
    top: 77px;
    right: 2px;
    bottom: 68px;
    left: 2px;
    height: auto;
  }

  .bet-warp {
    max-height: 100%;
    padding: 0 13px;
    overflow-y: scroll;
    .scrollbar(2px; #ccc);
  }

  & .v-retry-main {
    color: #333;
  }

  & .footer {
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    padding: 12px 20px;
    background: #fff;
    box-shadow: 0 -2px 6px 0 rgba(0, 0, 0, 12%);

    .v-button {
      max-width: 320px;
      height: 44px;
      margin: 0 auto;
      line-height: 44px;
    }
  }
}

.m-bookingCode-share {
  .m-share-booking-code {
    margin: 20px 0 15px;
    color: #333;
    font-size: 18px;
    text-align: center;
  }
}

.share-booking-info .top-detail {
  .code-value {
    margin: 12px 0 14px;
    color: #333;
    font-size: 28px;
    font-weight: 700;
    text-align: center;
  }

  .followed-times {
    color: #333;
    font-size: 12px;
    line-height: 16px;
  }

  .description {
    margin: 6px 0 10px;
    color: #333;
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 20px;
  }
}

// 分享背景
.m-share-ticket.share {
  background: #ffca27;
}
</style>

<style lang="less">
.dialog-addBetslip-limitNote {
  z-index: 99999;
}
</style>